// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import React from 'react'
import { alphaSort } from '../../../common/utils'
import { i18n } from '../../index'
import WastePercentageRow from './WastePercentageRow'
import type { VitrineProduct } from './vitrineProductTypes'
import css from './wastePercentageTable.css'
type Props = {
  type: string
  data: Array<VitrineProduct>
}
type State = {
  data: Array<VitrineProduct>
}

class WastePercentageTable extends React.Component<Props, State> {
  state = {
    data: alphaSort('name', this.props.data),
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.type !== this.props.type) {
      this.setState({
        data: alphaSort('name', this.props.data),
      })
    }
  }

  onEdit = (e: React.SyntheticEvent<HTMLInputElement>, index: number) => {
    const data = [...this.state.data]
    data[index] = { ...data[index], wastePercent: Number(e.target.value) }
    this.setState({
      data,
    })
  }

  render() {
    const { data } = this.state
    return (
      <div className={css.component}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={css.tableHeading}>
                {i18n.t('admin.vitrineProducts.wastePercentage.label.name')}
              </TableCell>
              <TableCell className={css.tableHeading}>
                {i18n.t('admin.vitrineProducts.wastePercentage.label.wastePercent')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length ? (
              data.map((vitrineProduct, i) => (
                <WastePercentageRow key={vitrineProduct.id} index={i} data={vitrineProduct} onEdit={this.onEdit} />
              ))
            ) : (
              <p className={css.empty}>{i18n.t('admin.vitrineProducts.products.noProducts')}</p>
            )}
          </TableBody>
        </Table>
      </div>
    )
  }
}

export default WastePercentageTable
